import { render } from "./Pricing.layout.vue?vue&type=template&id=c519a680"
import script from "./Pricing.layout.vue?vue&type=script&lang=js"
export * from "./Pricing.layout.vue?vue&type=script&lang=js"

import "./Pricing.layout.vue?vue&type=style&index=0&id=c519a680&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QHeader from 'quasar/src/components/header/QHeader.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QHeader,QToolbar,QBtn,QToolbarTitle});
